import { useState } from "react";
import { Link } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const LINKS = [
  ["What it does", "/solutions/inventory", "public-nav-solutions"],
  ["Freight calculator", "/tools/freight-calculator", "public-nav-freight"],
  ["Finance checker", "/tools/finance-checker", "public-nav-finance"],
  ["Guides", "/learn", "public-nav-learn"],
  ["News", "/news", "public-nav-news"],
  ["Markets", "/markets", "public-nav-markets"],
  ["World board", "/world-markets", "public-nav-world"],
  ["Fashion trends", "/fashion-trends", "public-nav-fashion"],
  ["Food court", "/food-court", "public-nav-food-court"],
  ["On offer", "/ads", "public-nav-ads"],
  ["Catalogue", "/catalogue", "public-nav-catalogue"],
  ["Rest & sleep", "/rest-sleep-board", "public-nav-rest-sleep"],
  ["Stretching", "/stretching", "public-nav-stretching"],
  ["Teamwork", "/teamwork", "public-nav-teamwork"],
  ["Notices", "/notices", "public-nav-notices"],
  ["Accessibility", "/accessibility", "public-nav-accessibility"],
  ["Remote pantry", "/pantry", "public-nav-pantry"],
  ["Companion rides", "/rides", "public-nav-rides"],
  ["Living near work", "/housing", "public-nav-housing"],
  ["Farmers market", "/farmers-market", "public-nav-farmers"],
  ["Workplace fridge", "/workplace-fridge", "public-nav-fridge"],
  ["Car care", "/car-care", "public-nav-car-care"],
  ["Price lock", "/price-lock", "public-nav-price-lock"],
  ["English course", "/english", "public-nav-english"],
  ["Parts integrity", "/parts-guard", "public-nav-parts-guard"],
  ["Motels", "/motels", "public-nav-motels"],
  ["Drinks", "/refreshments", "public-nav-refreshments"],
  ["Videos", "/videos", "public-nav-videos"],
  ["Live feed", "/feed", "public-nav-feed"],
  ["iPhone", "/iphone", "public-nav-iphone"],
  ["Android", "/android", "public-nav-android"],
];

export const PublicShell = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      <header className="sticky top-0 z-40 border-b border-border bg-white/95 backdrop-blur">
        <nav className="mx-auto flex max-w-5xl items-center gap-3 px-5 py-4 sm:px-8" data-testid="public-nav">
          <Link to="/" data-testid="public-nav-home" className="font-display text-lg font-bold tracking-tight text-[#0F172A]">
            Unity &amp; Utility
          </Link>

          <div className="ml-auto hidden flex-wrap items-center gap-x-4 gap-y-2 text-xs font-semibold uppercase tracking-wider text-slate-600 lg:flex">
            {LINKS.map(([label, to, testid]) => (
              <Link key={to} to={to} data-testid={testid} className="transition-colors duration-150 hover:text-[#002FA7]">
                {label}
              </Link>
            ))}
            <Link to="/register" data-testid="public-nav-register" className="bg-[#002FA7] px-3 py-1.5 text-white transition-colors duration-150 hover:bg-[#00248A]">
              Get started
            </Link>
          </div>

          <Link
            to="/register"
            data-testid="public-nav-register-mobile"
            className="ml-auto bg-[#002FA7] px-3 py-2 text-xs font-semibold uppercase tracking-wider text-white lg:hidden"
          >
            Get started
          </Link>
          <button
            type="button"
            data-testid="public-menu-button"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 shrink-0 items-center justify-center border border-border text-[#0F172A] lg:hidden"
          >
            {open ? <X size={20} /> : <List size={20} />}
          </button>
        </nav>

        {open && (
          <div className="border-t border-border bg-white lg:hidden" data-testid="public-mobile-menu">
            <div className="mx-auto grid max-w-5xl grid-cols-2 gap-x-4 px-5 pb-4 sm:px-8">
              {LINKS.map(([label, to, testid]) => (
                <Link
                  key={to}
                  to={to}
                  data-testid={`m-${testid}`}
                  onClick={() => setOpen(false)}
                  className="flex min-h-[44px] items-center border-b border-border/70 text-sm font-medium text-slate-700"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </header>
      {children}
      <footer className="border-t border-border bg-white">
        <div className="mx-auto grid max-w-5xl gap-6 px-5 py-10 text-sm sm:grid-cols-3 sm:px-8" data-testid="public-footer">
          <div>
            <p className="overline text-slate-500">What it does</p>
            <ul className="mt-2 space-y-1">
              {[["Inventory", "/solutions/inventory"], ["Tool crib", "/solutions/tool-crib"],
                ["Freight", "/solutions/freight"], ["Safety", "/solutions/safety"],
                ["Finance", "/solutions/finance"], ["Jobs", "/solutions/jobs"]].map(([t, to]) => (
                <li key={to}><Link to={to} className="tap-safe text-slate-600 hover:text-[#002FA7]">{t}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="overline text-slate-500">Free tools &amp; guides</p>
            <ul className="mt-2 space-y-1">
              <li><Link to="/tools/freight-calculator" className="tap-safe text-slate-600 hover:text-[#002FA7]">Freight quote calculator</Link></li>
              <li><Link to="/tools/finance-checker" className="tap-safe text-slate-600 hover:text-[#002FA7]">Finance &amp; scheme checker</Link></li>
              <li><Link to="/learn" className="tap-safe text-slate-600 hover:text-[#002FA7]">Practical guides</Link></li>
              <li><Link to="/news" className="tap-safe text-slate-600 hover:text-[#002FA7]">News</Link></li>
              <li><Link to="/markets" className="tap-safe text-slate-600 hover:text-[#002FA7]">Markets</Link></li>
              <li><Link to="/world-markets" className="tap-safe text-slate-600 hover:text-[#002FA7]">World board</Link></li>
              <li><Link to="/fashion-trends" className="tap-safe text-slate-600 hover:text-[#002FA7]">Fashion trends</Link></li>
              <li><Link to="/food-court" className="tap-safe text-slate-600 hover:text-[#002FA7]">Food court</Link></li>
              <li><Link to="/videos" className="tap-safe text-slate-600 hover:text-[#002FA7]">Videos</Link></li>
              <li><Link to="/feed" className="tap-safe text-slate-600 hover:text-[#002FA7]">Live from the yard</Link></li>
              <li><Link to="/iphone" className="tap-safe text-slate-600 hover:text-[#002FA7]">On your iPhone</Link></li>
              <li><Link to="/android" className="tap-safe text-slate-600 hover:text-[#002FA7]">On Android</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-slate-500">Company</p>
            <ul className="mt-2 space-y-1">
              <li><Link to="/login" className="tap-safe text-slate-600 hover:text-[#002FA7]">Sign in</Link></li>
              <li><Link to="/register" className="tap-safe text-slate-600 hover:text-[#002FA7]">Create an account</Link></li>
              <li><Link to="/legal/privacy" className="tap-safe text-slate-600 hover:text-[#002FA7]">Privacy</Link></li>
              <li><Link to="/legal/terms" className="tap-safe text-slate-600 hover:text-[#002FA7]">Terms</Link></li>
              <li><Link to="/accessibility" className="tap-safe text-slate-600 hover:text-[#002FA7]">Accessibility</Link></li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
};

export const Crumbs = ({ items }) => (
  <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="mb-4 text-xs text-slate-500">
    {items.map(([label, to], i) => (
      <span key={to || label}>
        {i > 0 && <span className="mx-1.5">/</span>}
        {to ? <Link to={to} className="hover:text-[#002FA7]">{label}</Link> : <span className="text-slate-700">{label}</span>}
      </span>
    ))}
  </nav>
);
